import { createContext, type PropsWithChildren, useContext } from 'react';

import type { BaseComponentProps } from './types';

const Context = createContext<Partial<BaseComponentProps>>({});

type PlotDataProviderProps = PropsWithChildren<{
  value: BaseComponentProps;
}>;

export const PlotDataProvider: React.FC<PlotDataProviderProps> = ({
  value,
  children,
}) => <Context.Provider value={value}>{children}</Context.Provider>;

// outside of the plot context this data will not necessarily be defined as expected
export const usePlotDataContext = <TInternalProps extends {}>(
  props: TInternalProps,
) => {
  const baseData = useContext(Context) as BaseComponentProps;

  return {
    ...baseData,
    ...props,
  };
};
